require("stylesheets/components/buttons/saveButton.scss");

var IndicatorButton = require("./indicatorButton.js").IndicatorButton;

class SaveButton extends IndicatorButton{
  constructor(){
    super('saveButton', 'saved');
  }

  get saved(){
    return this.indicator;
  }

  set saved(saved){
    return this.indicator = saved;
  }
}

var toExport = {
  SaveButton
};

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined'){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}



/** WEBPACK FOOTER **
 ** ./src/components/buttons/saveButton.js
 **/